<template>
  <div
    class="z-50 max-h-56 min-w-48 overflow-auto rounded-md border border-obsidian-200 bg-white p-1 shadow-lg"
  >
    <button
      v-for="(item, index) in items"
      :key="item.id"
      type="button"
      class="flex w-full items-center gap-2 rounded-sm px-2 py-1 text-left text-sm transition-colors"
      :class="
        index === selectedIndex
          ? 'bg-hazel-100 text-obsidian-900'
          : 'text-obsidian-700 hover:bg-hazel-50'
      "
      @click="selectItem(index)"
      @mouseenter="selectedIndex = index"
    >
      <CommentAvatar
        size="sm"
        :user-id="item.id"
        :first-name="item.firstName"
        :last-name="item.lastName"
      />
      <span class="truncate">{{ item.firstName }} {{ item.lastName }}</span>
    </button>
    <p v-if="!items.length" class="px-2 py-1.5 text-sm text-obsidian-500">
      {{ emptyText }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import CommentAvatar from './CommentAvatar.vue';
import type { CommentMentionCandidate } from '@/api/comments.service';

const props = defineProps<{
  items: CommentMentionCandidate[];
  command: (item: { id: string; label: string }) => void;
  emptyText: string;
}>();

const selectedIndex = ref(0);

watch(
  () => props.items,
  () => {
    selectedIndex.value = 0;
  },
);

const selectItem = (index: number) => {
  const item = props.items[index];
  if (!item) return;
  props.command({ id: item.id, label: `${item.firstName} ${item.lastName}`.trim() });
};

const onKeyDown = ({ event }: { event: KeyboardEvent }) => {
  if (event.key === 'ArrowUp') {
    selectedIndex.value =
      (selectedIndex.value + props.items.length - 1) % Math.max(props.items.length, 1);
    return true;
  }
  if (event.key === 'ArrowDown') {
    selectedIndex.value = (selectedIndex.value + 1) % Math.max(props.items.length, 1);
    return true;
  }
  if (event.key === 'Enter') {
    selectItem(selectedIndex.value);
    return true;
  }
  return false;
};

defineExpose({ onKeyDown });
</script>
